<template>
    <div class="w-full">
        <div class="rounded-lg min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[70%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-2xl text-black font-normal">Resumption from Leave or Approved Absence</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Name: {{ nom ?? "" }}</th>
                            <th class="text-2xl text-black font-normal">Department: {{ departement ?? "" }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="text-2xl text-black font-normal">Leave or absence period</th>
                            <th class="text-2xl text-black font-normal">{{ startDate ?? "" }} - {{ endDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Type of leave</th>
                            <th class="text-2xl text-black font-normal">{{ type ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Resumption date</th>
                            <th class="text-2xl text-black font-normal">{{ reprise ?? "" }}</th>
                        </tr>
                    </tbody>
                </table>
                <div class="mt-20 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        Employee’s signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-20 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        Supervisor’s signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-20 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        HR Office signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-40 text-gray-700 mb-4 flex text-[11px]">
                    <p>
                        <span class="font-bold">Provision</span>: This form should be MANDATORILY completed by the employee upon his resumption and sent to the
                        HR Office on the same day.
                    </p>
                </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "ResumptionFromLeaveValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            departement: null,
            startDate: null,
            endDate: null,
            type: null,
            reprise: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.departement= JSON.parse(data.data["data"]["content"]).departement
                    this.startDate= JSON.parse(data.data["data"]["content"]).startDate
                    this.endDate= JSON.parse(data.data["data"]["content"]).endDate
                    this.type= JSON.parse(data.data["data"]["content"]).type
                    this.reprise= JSON.parse(data.data["data"]["content"]).reprise
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            const signature = localStorage.getItem("signature") ?? undefined;
            if(!signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : localStorage.getItem("signature")
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        console.log(response.data);
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>